/* eslint eqeqeq: off */
import React from "react";
import './index.css';
import Modal, {ModalAction, ModalContent, ModalControls} from "../../../Components/Modal";
import Button from "../../../Components/Control/Button";
import Input from "../../../Components/Control/Input";
import {connect} from "react-redux";
import moment from "jalali-moment";
import Date from "../../../Components/Control/Date";
import Resource from "../../../Resource";
import PropTypes from 'prop-types';
import Separator from "../../../Components/Control/Separator";
import Label from "../../../Components/Control/Label";
import Radio from "../../../Components/Control/Radio";
import Check from "../../../Components/Control/Check";
import {updateBase} from "../../../Redux/Actions/base";
import Time from "../../../Components/Control/Time";
import {Tool} from "../../../App";
import ValidationSpot from "../../../Components/Control/ValidationSpot";
import ModalPrint from "../ModalPrint";
import Notif from "../../../Components/Notif";
import ModalSectionWashRequest from "../ModalWashRequest";
import {SectionNormRequest} from '../../../Server/NormRequest';
import MyComponent from '../../../Components/MyComponent';

class ModalBloodSampleCompletion extends MyComponent {
    constructor(props) {
        super(props);
        props.refer.current = this;


        this.state = {
            error: null,
            loading: null,
            fields: {}
        };

        this.ref = {
            modal: React.createRef(),
            modalPrint: React.createRef(),
            termsAndConditions: React.createRef(),
            sampler: React.createRef(),
            samplerName: React.createRef(),
            samplerLastName: React.createRef(),
            bloodSamplingDate: React.createRef(),
            bloodSamplingTime: React.createRef(),
            update: React.createRef(),
            printLabel: React.createRef(),
        };
    }

    static defaultProps = {
        refer: {current: null},
        onClose: _ => null,
        onSuccess: _ => null
    };

    static propTypes = {
        refer: PropTypes.object,
        onClose: PropTypes.func,
        onSuccess: PropTypes.func
    };

    validations = {
        termsAndConditions: x => x === false || x === true || 'تاییدیه فرم انتخاب نشده است.',
        sampler: x => x === false || x === true || 'نقش نمونه گیر انتخاب نشده است.',
        samplerName: x => Boolean(x) || 'نام نمونه گیر وارد نشده است.',
        samplerLastName: x => Boolean(x) || 'نام خانوادگی نمونه گیر وارد نشده است.',
        bloodSamplingDate: x => Boolean(x) || 'تاریخ نمونه گیری وارد نشده است.',
        bloodSamplingTime: x => Boolean(x) || 'ساعت نمونه گیری وارد نشده است.',
    };

    componentDidMount() {

    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        const {state, props} = this;

        return state.action !== nextState.action ||
            state.error !== nextState.error ||
            state.loading !== nextState.loading ||
            state.fields !== nextState.fields ||
            props.base.sectionNormRequestFormPrintView !== nextProps.base.sectionNormRequestFormPrintView ||
            props.base.normRequestFormPrintOnSubmit !== nextProps.base.normRequestFormPrintOnSubmit;
    }

    render() {
        const {state, props, ref} = this;
        const readOnly = this.state.action === ModalAction.VIEW;

        return <React.Fragment>
            <Modal ref={ref.modal}
                   name={'ModalBloodSampleCompletion'}
                   size={'large'}
                   title={'فرم تکمیل اطلاعات نمونه‌گیر'}
                   required={true}
                   error={this.state.error}
                   loading={this.state.loading}
                   onClose={this.props.onClose}>
                <ModalContent>
                    {props.base.sectionNormRequestFormPrintView ?
                        <table>
                            <tbody>
                            <tr>
                                <td colSpan={10}><Label style={{backgroundColor: '#6eba66', color: 'white', padding: '5px 0'}} align={'center'}>این قسمت توسط نمونه گیر تکمیل شود.</Label></td>
                            </tr>
                            <tr>
                                <td colSpan={10}>
                                    <ValidationSpot ref={ref.termsAndConditions} label={'تاییدیه'} validation={this.validations.termsAndConditions} readOnly={readOnly}>
                                        <Label className={'fb-20'}>اینجانب تایید می‌نمایم که نمونه خون از بیمار با مشخصات قید شده در این فرم اخذ شده و شناسایی از طریق‌ <Radio style={{display: 'inline'}} readOnly={readOnly} name={'termsAndConditions'} label={'پرسش مستقیم از بیمار'} checked={state?.fields?.termsAndConditions === false} onClick={this.setField.bind(this, 'termsAndConditions', false)}/> و یا <Radio style={{display: 'inline'}} readOnly={readOnly} name={'termsAndConditions'} label={'مشاهده مچ بند'} checked={state?.fields?.termsAndConditions === true} onClick={this.setField.bind(this, 'termsAndConditions', true)}/> حاصل شده و نمونه در همان زمان برچسب زده شده است.</Label>
                                    </ValidationSpot>
                                    <div className="dis-f">
                                        <Label>مشخصات نمونه گیر :</Label>
                                        <ValidationSpot ref={ref.sampler} label={'نقش نمونه گیر'} validation={this.validations.sampler} className="dis-f">
                                            <Radio className={'pad-h-4'} readOnly={readOnly} name={'sampler'} label={'پرستار'} checked={state?.fields?.sampler === true} onClick={this.setField.bind(this, 'sampler', true)}/>
                                            <Radio className={'pad-h-4'} readOnly={readOnly} name={'sampler'} label={'پرسنل آزمایشگاه'} checked={state?.fields?.sampler === false} onClick={this.setField.bind(this, 'sampler', false)}/>
                                        </ValidationSpot>
                                    </div>
                                    <div className="dis-f fb-20">
                                        <Input ref={ref.samplerName} readOnly={readOnly} className={'pad-4 fb-4 '} label={'نام'} validation={this.validations.samplerName} value={state?.fields?.samplerName} onChange={this.setField.bind(this, 'samplerName')}/>
                                        <Input ref={ref.samplerLastName} readOnly={readOnly} className={'pad-4 fb-6'} label={'نام خانوادگی'} validation={this.validations.samplerLastName} value={state?.fields?.samplerLastName} onChange={this.setField.bind(this, 'samplerLastName')}/>
                                        <Date ref={ref.bloodSamplingDate} readOnly={readOnly} className={'pad-4 fb-6'} label={'تاریخ خونگیری'} validation={this.validations.bloodSamplingDate} value={state?.fields?.bloodSamplingDate} onChange={this.setField.bind(this, 'bloodSamplingDate')}/>
                                        <Time ref={ref.bloodSamplingTime} readOnly={readOnly} className={'pad-4 fb-4 '} label={'ساعت خونگیری'} validation={this.validations.bloodSamplingTime} placeholder={'__:__'} value={state?.fields?.bloodSamplingTime} onChange={this.setField.bind(this, 'bloodSamplingTime')}/>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td colSpan={10} style={{backgroundColor: '#c2dfae'}}><Label>این فرم در 2 نسخه تکمیل گردد. پس از ارسال هر دو نسخه به بانک خون و ثبت درخواست، نسخه زرد رنگ در بانک خون باقی مانده و نسخه اصلی فرم جهت نگهداری در پرونده، مجددا به بخش ارسال می‌گردد. <span style={{color: '#ea4335'}}>در مواقع نیاز به خون اورژانس به جای این فرم، فرم درخواست خون و فرآورده‌های خونی به طور اورژانس (تهیه کمتر از 30 دقیقه) به شماره 00.HV.007.GDL تکمیل شود.</span></Label></td>
                            </tr>
                            </tbody>
                        </table> :
                        <div className={'dis-f'}>
                            <div className={'dis-f fb-20'}>
                                <ValidationSpot ref={ref.termsAndConditions} label={'تاییدیه'} validation={this.validations.termsAndConditions} readOnly={readOnly}>
                                    <Label className={'fb-20'}>اینجانب تایید می‌نمایم که نمونه خون از بیمار با مشخصات قید شده در این فرم اخذ شده و شناسایی از طریق‌ <Radio style={{display: 'inline'}} readOnly={readOnly} name={'termsAndConditions'} label={'پرسش مستقیم از بیمار'} checked={state?.fields?.termsAndConditions === false} onChange={this.setField.bind(this, 'termsAndConditions', false)}/> و یا <Radio style={{display: 'inline'}} readOnly={readOnly} name={'termsAndConditions'} label={'مشاهده مچ بند'} checked={state?.fields?.termsAndConditions === true} onChange={this.setField.bind(this, 'termsAndConditions', true)}/> حاصل شده و نمونه در همان زمان برچسب زده شده است.</Label>
                                </ValidationSpot>
                                <Separator/>
                                <Label>مشخصات نمونه گیر :</Label>
                                <ValidationSpot ref={ref.sampler} label={'نقش نمونه گیر'} validation={this.validations.sampler} className="dis-f fb-2x-20 dis-2x-b" readOnly={readOnly}>
                                    <Radio className={'pad-h-4'} readOnly={readOnly} name={'sampler'} label={'پرستار'} checked={state?.fields?.sampler === true} onChange={this.setField.bind(this, 'sampler', true)}/>
                                    <Radio className={'pad-h-4'} readOnly={readOnly} name={'sampler'} label={'پرسنل آزمایشگاه'} checked={state?.fields?.sampler === false} onChange={this.setField.bind(this, 'sampler', false)}/>
                                </ValidationSpot>
                                <div className="dis-f fb-20">
                                    <Input ref={ref.samplerName} readOnly={readOnly} className={'pad-4 fb-4 fb-3x-8 fb-2x-20'} label={'نام'} validation={this.validations.samplerName} value={state?.fields?.samplerName} onChange={this.setField.bind(this, 'samplerName')}/>
                                    <Input ref={ref.samplerLastName} readOnly={readOnly} className={'pad-4 fb-6 fb-3x-12 fb-2x-20'} label={'نام خانوادگی'} validation={this.validations.samplerLastName} value={state?.fields?.samplerLastName} onChange={this.setField.bind(this, 'samplerLastName')}/>
                                    <Date ref={ref.bloodSamplingDate} readOnly={readOnly} className={'pad-4 fb-6 fb-3x-12 fb-2x-20'} label={'تاریخ خونگیری'} validation={this.validations.bloodSamplingDate} value={state?.fields?.bloodSamplingDate} onChange={this.setField.bind(this, 'bloodSamplingDate')}/>
                                    <Time ref={ref.bloodSamplingTime} readOnly={readOnly} className={'pad-4 fb-4 fb-3x-8 fb-2x-20'} label={'ساعت خونگیری'} validation={this.validations.bloodSamplingTime} placeholder={'__:__'} value={state?.fields?.bloodSamplingTime} onChange={this.setField.bind(this, 'bloodSamplingTime')}/>
                                </div>
                            </div>
                        </div>}
                </ModalContent>
                <ModalControls>
                    <Check className={'mar-4'} label={'نمایش فرم اصلی'} checked={props.base.sectionNormRequestFormPrintView} onChange={this.formViewChangeHandler.bind(this)}/>
                    <div className="flex"/>
                    <Button refer={ref.update} className={'mar-4'} theme={'blue'} onClick={this.updateClickHandler.bind(this)}>ویرایش درخواست</Button>
                    <Button refer={ref.close} className={'mar-4'} onClick={this.close.bind(this)}>بستن</Button>
                </ModalControls>
            </Modal>
            <ModalPrint refer={this.ref.modalPrint}/>
            <ModalSectionWashRequest refer={this.ref.modalSectionWashRequest}/>
        </React.Fragment>;
    }

    close(success) {
        this.ref.modal.current.close();

        if (success === true)
            this.props.onSuccess();

        this.props.onClose();
    }

    fieldWillUpdate(keys, value, currentFields, nextFields) {
        const {ref} = this;

        switch (keys[0]) {
            case 'termsAndConditions':
            case 'sampler':
                ref[keys[0]].current.validate(value);
                break;
            default:
        }
    }

    formViewChangeHandler(flag) {
        this.props.updateBase({sectionNormRequestFormPrintView: flag});
    }

    open(data, action) {
        if (action === ModalAction.INSERT) {
            this.setState({
                data,
                action,
                fields: {},
                error: null,
                loading: 'در حال دریافت اطلاعات درخواست'
            });

            SectionNormRequest.data({
                sectionNormRequestId: data.sectionRequestId
            })
                .then(data => {
                    this.setState({
                        data,
                        loading: null,
                        fields: {
                            ...this.state.fields,
                            bloodSamplingDate: data.bloodSamplingDate ? moment(data.bloodSamplingDate) : null,
                            bloodSamplingTime: data.bloodSamplingTime ? moment(data.bloodSamplingTime).format('HH:mm') : '',
                            sampler: data.sampler,
                            samplerLastName: data.samplerLastName,
                            samplerName: data.samplerName,
                            termsAndConditions: data.termsAndConditions
                        }
                    });
                })
                .catch(message => {
                    new Notif({message, theme: 'error'}).show();

                    this.ref.modal.current.close();
                });
        }

        this.ref.modal.current.open();
    }

    updateClickHandler() {
        const {ref, state} = this;

        if (this.validate()) {
            ref.update.current.loading();
            this.setState({error: null});
            SectionNormRequest.update({
                sectionRequestId: state.data?.sectionRequestId,
                sectionNormRequestId: state.data?.sectionNormRequestId,
                patientFirstName: state?.patientFileInfo?.patientFileCodeId ? null : state?.fields?.patientFirstName,
                patientLastName: state?.patientFileInfo?.patientFileCodeId ? null : state?.fields?.patientLastName,
                patientFatherName: state?.patientFileInfo?.patientFileCodeId ? null : state?.fields?.patientFatherName,
                patientBirthDate: state?.patientFileInfo?.patientFileCodeId ? null : state?.fields?.patientBirthDate.format('jYYYY-jMM-jDD'),
                patientNationalCode: state?.patientFileInfo?.patientFileCodeId ? null : state?.fields?.patientNationalCode?.toString() || null,
                patientGenderId: state?.patientFileInfo?.patientFileCodeId ? null : state?.fields?.patientGenderId,
                patientProvinceId: state?.patientFileInfo?.patientFileCodeId ? null : state?.fields?.patientProvinceId[0]?.id,
                patientCityId: state?.patientFileInfo?.patientFileCodeId ? null : state?.fields?.patientCityId[0]?.id,
                sectionId: state?.fields?.sectionId[0]?.id,
                patientFileCode: state?.patientFileInfo?.patientFileCodeId ? null : state?.fields?.patientFileCode,
                patientFileCodeId: state?.patientFileInfo?.patientFileCodeId || null,
                injectionHistory: state?.fields?.injectionHistory,
                pregnancyHistory: state?.fields?.pregnancyHistory,
                complicationsHistory: state?.fields?.complicationsHistory,
                antiBodyHistory: state?.fields?.antiBodyHistory,
                medicationPrescribeNeed: state?.fields?.medicationPrescribeNeed,
                medicationName: state?.fields?.medicationName,
                howToPrescribe: state?.fields?.howToPrescribe,
                patientDiagnosticId: state?.fields?.patientDiagnosticId[0]?.id,
                patientDiagnosticStr: state?.fields?.patientDiagnosticStr,
                diseaseCauseId: state?.fields?.diseaseCauseId,
                surgeryTypeId: (state?.fields?.surgeryTypeId || [])[0]?.id,
                diseaseCauseOtherReason: state?.fields?.diseaseCauseOtherReason,
                hemoglobinAmount: state?.fields?.hemoglobinAmount,
                pltamount: state?.fields?.pltamount,
                patientBloodGroupId: (state?.fields?.patientBloodGroupId || [])[0]?.id,
                rbccount: state?.fields?.rbccount,
                wbcount: state?.fields?.wbcount,
                lrbccount: state?.fields?.lrbccount,
                ffpcount: state?.fields?.ffpcount,
                pediatricCount: state?.fields?.pediatricCount,
                crycount: state?.fields?.crycount,
                washedRbccount: state?.fields?.washedRbccount,
                washedTime: state?.fields?.washedTime,
                cppcount: state?.fields?.cppcount,
                otherProductsCount: state?.fields?.otherProductsCount,
                otherProductsName: state?.fields?.otherProductsName,
                pltcount: state?.fields?.pltcount,
                requestPurpose: state?.fields?.requestPurpose,
                needDate: moment(`${state?.fields?.needDate.format('jYYYY-jMM-jDD')} ${state?.fields?.needTime || '00:00'}`, 'jYYYY-jMM-jDD HH:mm').format(),
                injectionVelocity: state?.fields?.injectionVelocity,
                docterId: state?.fields?.docterId?.[0]?.id,
                rhtest: state?.fields?.rhtest,
                antiBodyTest: state?.fields?.antiBodyTest,
                crossMatchTest: state?.fields?.crossMatchTest,
                termsAndConditions: state?.fields?.termsAndConditions,
                sampler: state?.fields?.sampler,
                samplerName: state?.fields?.samplerName,
                samplerLastName: state?.fields?.samplerLastName,
                bloodSamplingDate: state?.fields?.bloodSamplingDate ? state?.fields?.bloodSamplingDate.format() : null,
                bloodSamplingTime: state?.fields?.bloodSamplingTime ? moment(`${state?.fields?.bloodSamplingDate.format('jYYYY-jMM-jDD')} ${state?.fields?.bloodSamplingTime}`, 'jYYYY-jMM-jDD HH:mm').format() : null,
            }).then(_ => {
                new Notif(Resource.STRING.FETCH.UPDATE_SUCCESSFUL).show();
                ref.update.current.loading(false);

                this.close(true);
            }).catch(message => {
                ref.update.current.loading(false);
                this.setState({error: message});
            });
        }
    }

    validate() {
        const {state, ref} = this;
        const validate = Tool.validate(
            [ref.termsAndConditions, state?.fields?.termsAndConditions],
            [ref.sampler, state?.fields?.sampler],
            ref.samplerName,
            ref.samplerLastName,
            ref.bloodSamplingDate,
            ref.bloodSamplingTime
        );

        if (validate !== true)
            new Notif({message: validate.message, theme: 'error'}).show();

        return validate === true;
    }
}

const mapStateToProps = state => {
    return {
        base: state.base,
        user: state.user
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ModalBloodSampleCompletion);